export default __webpack_public_path__ + "static/media/strikethrough.6bb9eac5.svg";